export default "__VITE_ASSET__6e1a691b__"